import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import CustomTabPanel from '../../../components/CustomTabPanel';
import { useContent } from '../../../context/ContentContext';
import { ContentType } from '../../../models/Content';
import { Content as ContentInterface } from '../../../models/Content';
import Banners from './Banners';
import Terms from './Terms';
import Loading from '../../../components/global/loading/Loading';

function Content() {
  const { createContent, getAllContent, updateContent } = useContent();

  const [data, setData] = React.useState<ContentInterface[]>([]);

  const [regulamin, setRegulamin] = React.useState<string | null>(null);

  useEffect(() => {
    const getData = async () => {
      const terms = await getAllContent();
      const regulaminContent = terms.find(
        (content) => content.content_key === 'terms_and_conditions',
      );
      if (regulaminContent) {
        setRegulamin(regulaminContent.content_data);
      } else {
        setRegulamin('');
      }

      setData(terms);
    };

    getData();
  }, [getAllContent]);

  const saveTerms = async () => {
    if (!regulamin) {
      toast.error('Regulamin nie może być pusty');
      return;
    }
    const toastId = toast.loading('Zapisywanie regulaminu...');
    try {
      const termsContent = data.find(
        (content) => content.content_key === 'terms_and_conditions',
      );
      if (!termsContent) {
        await createContent(
          'terms_and_conditions',
          ContentType.TEXT,
          regulamin,
        );
      } else {
        await updateContent(
          termsContent.id,
          'terms_and_conditions',
          ContentType.TEXT,
          regulamin,
        );
      }

      toast.update(toastId, {
        render: 'Regulamin został zapisany',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error: any) {
      console.error('Failed to save terms', error);
      toast.update(toastId, {
        render: 'Wystąpił błąd podczas zapisywania regulaminu',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [panel, setPanel] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setPanel(newValue);
  };

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={panel}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Regulamin" {...a11yProps(0)} />
          <Tab label="Banery reklamowe" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={panel} index={0}>
        {regulamin === null ? (
          <Loading />
        ) : (
          <Terms
            terms={regulamin}
            setTerms={setRegulamin}
            saveTerms={saveTerms}
          />
        )}
      </CustomTabPanel>
      <CustomTabPanel value={panel} index={1}>
        <Banners />
      </CustomTabPanel>
    </div>
  );
}

export default Content;
